import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { TrackingDeviceAssignment } from '../../types/entity.types';
import {
  CreateTrackingDeviceAssignmentRequest,
  RetrieveTrackingDeviceAssignmentsRequest
} from './device-assignment.types';

import {
  requestCreateTrackingDeviceAssignment,
  requestRetrieveTrackingDeviceAssignments
} from './device-assignment.actions';

export const useDeviceAssignmentApi = () => {
  const dispatch = useDispatch();

  const createTrackingDeviceAssignment = useCallback(
    (requestData: CreateTrackingDeviceAssignmentRequest, onSuccess?: (data: TrackingDeviceAssignment) => void) => {
      dispatch(requestCreateTrackingDeviceAssignment({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const retrieveTrackingDeviceAssignments = useCallback(
    (requestData: RetrieveTrackingDeviceAssignmentsRequest, onSuccess?: (data: TrackingDeviceAssignment[]) => void) => {
      dispatch(requestRetrieveTrackingDeviceAssignments({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createTrackingDeviceAssignment, retrieveTrackingDeviceAssignments };
};
